import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getRoutePath } from '~/router/routes';

export default function FallbackMessage() {
  const navigate = useNavigate();
  const handleLoginClick = () => {
    navigate(getRoutePath('auth.login'));
  };
  return (
    <Box>
      <Typography
        variant="h1"
        sx={{ mb: 1, fontSize: '1.4em', color: 'text.primary', marginTop: 'auto', textWrap: 'pretty' }}>
        Sorry, our muscles are overloaded
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary', textWrap: 'pretty' }}>
        Please try to log back in and reach out if the issues continues.
      </Typography>
      <Button
        variant="contained"
        size="large"
        sx={{
          mt: 2,
          textTransform: 'none',
          p: 1.5,
        }}
        fullWidth
        onClick={handleLoginClick}>
        Log In
      </Button>
    </Box>
  );
}
